<template>
  <v-select
    v-if="selectedFieldData.name == 'lng_weather_1'"
    :items="selectFieldData"
    value="0"
    item-text="name"
    item-value="id"
  >
    <template v-slot:selection="{ item }">
      <span>
        <span>
          {{ selectedFieldData.value + " "
          }}{{ selectedFieldData.unit | translate }}
        </span>
        <span>{{ splittedName(selectedFieldData.name) }}</span>
      </span>
    </template>
    <template v-slot:item="{ item }">
      <span>{{ item.name }}</span>
    </template>
  </v-select>
  <v-select
    :class="
      selectedFieldData.id == 0 && selectedFieldData.selection == 0
        ? 'add-option'
        : ''
    "
    v-else
    :items="selectFieldData"
    :value="selectedFieldData.id"
    item-text="extendedName"
    item-value="id"
    menu-props="auto"
    return-object
    @change="saveSelectFieldData"
  >
    <template v-slot:selection="{ item }">
      <div
        v-if="selectedFieldData.id !== 0 && selectedFieldData.selection !== 0"
      >
        <span v-if="item.extendedName">
          <span>{{ item.extendedName }}</span>
          <span>{{ item.splitedName }}</span>
          <span
            class="ref-oxygen"
            v-if="selectedFieldData.id === '12' && refoxygen"
            >({{ refoxygen }})</span
          >
          <span
            class="ref-oxygen"
            v-if="selectedFieldData.id === '26' && refAirflow"
            >({{ refAirflow }})</span
          >
        </span>
        <span v-else>{{ item.name }}</span>
      </div>
    </template>
    <template v-slot:item="{ item }">
      <span>{{ item.name }}</span>
    </template>
  </v-select>
</template>

<script>
import { translate } from "../../common/HelperFunctions";

export default {
  name: "HomeSelectFieldItem",
  data: () => ({
    fieldList: {},
    selectFieldData: [],
    selectedFieldData: {},
    refoxygen: "",
    refAirflow: ""
  }),
  props: {
    fieldOptions: {
      type: Array,
      default: () => []
    },
    fieldData: {
      type: Object,
      default: () => {}
    },
    frontData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    fieldOptions: function(newVal) {
      this.fieldList = newVal;
    },
    fieldData: function(newVal) {
      this.selectedFieldData = newVal;
      this.setfrontDataValue();
      this.selectFieldsInitialize();
    }
  },
  async mounted() {
    this.fieldList = this.fieldOptions;
    this.selectedFieldData = this.fieldData;
    this.setfrontDataValue();
    this.selectFieldsInitialize();
  },
  methods: {
    splittedName(name) {
      return translate(name).split(" (")[0];
    },
    setfrontDataValue() {
      this.frontData.forEach(element => {
        if (element.id === "refoxygen") {
          this.refoxygen = element.value;
        }
        if (element.id === "refair") {
          this.refAirflow = element.value;
        }
      });
    },
    // initilize the select field items data
    selectFieldsInitialize() {
      let parsedData = [];
      for (let i = 0; i < this.fieldList.length; i++) {
        let selectItem = {};
        selectItem.id = this.fieldList[i]["@attributes"].id;
        selectItem.name = this.fieldList[i]["@attributes"].txtid
          ? translate(this.fieldList[i]["@attributes"].txtid)
          : "";
        if (
          this.selectedFieldData.id == this.fieldList[i]["@attributes"].id &&
          this.selectedFieldData.selection
        ) {
          selectItem.extendedName = this.selectedFieldData.unit
            ? this.selectedFieldData.value +
              " " +
              translate(this.selectedFieldData.unit)
            : this.selectedFieldData.value;
          selectItem.splitedName = translate(
            this.fieldList[i]["@attributes"].txtid
          ).split(" (")[0];
        }
        parsedData.push(selectItem);
      }
      this.selectFieldData = parsedData;
    },
    // function that called in parent to save select field data
    saveSelectFieldData(fieldData) {
      this.$emit("saveSelectData", fieldData);
    }
  }
};
</script>
